import React from 'react';
import { FadeIn } from './FadeIn';
export function PainSection() {
  return <section className="py-10 bg-white" data-id="element-87" data-mp="38xwtwht0vg3k">
      <div className="container mx-auto px-4" data-id="element-88" data-mp="38wlt8quviogo">
        <div className="max-w-3xl mx-auto" data-id="element-89" data-mp="38vkeocenfju7">
          <FadeIn data-id="element-90" data-mp="2ux41c2ma6v33">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-6" data-id="element-91" data-mp="2uxm29cjw1xhc">
              Mientras tratás de conectar... los días pasan. 💔
            </h2>
          </FadeIn>

          <div className="space-y-3 mb-6" data-id="element-92" data-mp="2l7kigwykj188">
            <FadeIn delay={0.1} direction="left" data-id="element-93" data-mp="2pz2inisroxs5">
              <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-94" data-mp="2pzud2qamopgu">
                <div className="text-3xl shrink-0" data-id="element-95" data-mp="2bbr8nlc8hlu5">📱</div>
                <p className="text-base md:text-lg text-slate-700 pt-0.5" data-id="element-96" data-mp="2g8q0fx8fdgp6">
                  Todo se vuelve pantallas, trabajo y cansancio.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} direction="left" data-id="element-97" data-mp="2792vj1ghlsrd">
              <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-98" data-mp="277rw1du2r762">
                <div className="text-3xl shrink-0" data-id="element-99" data-mp="3rp3smtb9tvni">💤</div>
                <p className="text-base md:text-lg text-slate-700 pt-0.5" data-id="element-100" data-mp="3nkdzvdbwsx6t">
                  Terminás el día sintiendo que no aprovechaste el tiempo
                  juntos.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} direction="left" data-id="element-101" data-mp="emyosiuxe5b">
              <div className="flex items-start gap-4 p-4 bg-red-50 rounded-2xl border border-red-100" data-id="element-102" data-mp="38vrlbdu3w9gn">
                <div className="text-3xl shrink-0" data-id="element-103" data-mp="33yhld493cfek">⚠️</div>
                <p className="text-base md:text-lg text-slate-800 font-semibold pt-0.5" data-id="element-104" data-mp="3imceumuxansp">
                  Si no cambiás algo ahora, tus hijos crecerán con el recuerdo
                  de una tablet, no de un momento con vos.
                </p>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.4} data-id="element-105" data-mp="2l6ykp42jhdfp">
            <div className="text-center p-6 bg-brand-50 rounded-3xl border border-brand-100" data-id="element-106" data-mp="2l7qficobb74x">
              <p className="text-lg md:text-xl text-brand-900 font-bold italic" data-id="element-107" data-mp="p4lqt4sl74yl">
                "No es falta de amor, es que la rutina te roba el tiempo.
                Nosotros te devolvemos la brújula."
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}